package ui.app.assign.detail.definition

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.graphics.vector.*
import androidx.compose.ui.layout.*
import androidx.compose.ui.text.font.*
import androidx.compose.ui.unit.*
import api.*
import compose.assets.*
import compose.assets.svg.*
import ssoft.frontend.generated.resources.*
import tools.*
import ui.app.assign.detail.*
import ui.resource.*
import ui.widget.*
import kotlin.math.*


@Composable
fun AppDetailScope.AppDefOfVideo(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfVideo
) {

    if (display.isMobile) {
        Column {
            DefaultFields(
                nnvl = wrapper,
                modifier = Modifier.fillMaxWidth(),
                mainContent = {
                    VideoPicker(
                        nnvl = nnvl,
                        wrapper = wrapper,
                        modifier = Modifier.fillMaxWidth(),
                    )
                    Space(16.dp)
                },
                secondaryContent = {
                    VolumeControl(
                        wrapper = wrapper,
                        nnvl = nnvl,
                        modifier = Modifier.fillMaxWidth(),
                    )
                    Space(16.dp)
                })
        }
    } else {
        Row {
            Column(Modifier.weight(1F)) {
                DefaultFields(wrapper, Modifier.fillMaxWidth())
            }
            Space(16.dp)
            Column(Modifier.weight(1F)) {
                VideoPicker(nnvl, wrapper, Modifier.fillMaxWidth())
                Space(24.dp)
                VolumeControl(wrapper, nnvl, Modifier.fillMaxWidth())
            }
        }
    }
    Space(64.dp)
}


@Composable
private fun AppDetailScope.VideoPicker(
    nnvl: AppDetailScope.WrapperDefinition.OfVideo,
    wrapper: AppDetailScope.Wrapper,
    modifier: Modifier = Modifier.width(256.dp)
) {
    val imagePickerKey = remember(args.appId) {
        "VideoPicker:${args.appId}"
    }

    GlobalObjectShare.Consumer(imagePickerKey)

    Card(modifier) {
        Box {
            Column(Modifier.padding(16.dp)) {
                Text(Res.string.layer_bottom_detail__video_pick_label.rememberString())
                Space(8.dp)
                Card(Modifier.fillMaxWidth()) {
                    LazyImage(
                        id = nnvl.video.state,
                        modifier = Modifier.fillMaxWidth(),
                        contentScale = ContentScale.FillWidth
                    )

                }
            }
            if (wrapper.canEdit) {
                FloatingActionButton(
                    onClick = {
                        GlobalObjectShare.launchImagePicker(
                            key = imagePickerKey,
                            nav = nav,
                            args = ResourceListingArgs(
                                companyId = args.companyId,
                                restrictionType = ResourceType.VIDEO.mask,
                                restrictionCanIgnoreAspectRatio = true
                            )
                        ) {
                            it.firstOrNull()?.also { item ->
                                nnvl.video.set(item.id)
                            }
                        }
                    },
                    modifier = Modifier.align(Alignment.BottomEnd)
                ) {
                    Icon(
                        imageVector = Svg.Edit,
                        contentDescription = null
                    )
                }
            }
        }

    }
}

@Composable
private fun AppDetailScope.VolumeControl(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfVideo,
    modifier: Modifier = Modifier.width(256.dp)
) {

    Card(modifier = modifier) {
        Column(
            Modifier.padding(16.dp)
                .fillMaxWidth()
        ) {
            Text(Res.string.layer_bottom_detail__video_volume_default_label.rememberString())
            Space(8.dp)
            Card(colors = CardDefaults.cardColors(MaterialTheme.colorScheme.inverseSurface)) {
                PercentageEntry(nnvl.volume, wrapper.canEdit)

            }
            Space(8.dp)
            Text(Res.string.layer_bottom_detail__video_volume_max_label.rememberString())
            Space(8.dp)
            Card(colors = CardDefaults.cardColors(MaterialTheme.colorScheme.inverseSurface)) {
                PercentageEntry(nnvl.volumeMax, wrapper.canEdit)
            }
        }
    }
}

@Composable
fun AppDetailScope.PercentageEntry(
    volume: EFieldRegularFloat,
    canEdit: Boolean,
    icon: ImageVector? = null,
    steps: Int = 9
) {
    Row(
        modifier = Modifier.padding(horizontal = 8.dp),
        horizontalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        icon?.also {
            Icon(it, null)
        }
        Text(
            text = (volume.state * 100F).roundToInt().toString(),
            modifier = Modifier.align(Alignment.CenterVertically),
            fontWeight = FontWeight.Bold
        )
        Slider(
            enabled = canEdit,
            value = volume.state,
            valueRange = 0F..1F,
            steps = steps,
            onValueChange = { volume.set(it) }
        )
    }
}
